<template>
  <v-container fluid grid-list-md style="padding: 30px;">
    <v-row dense>
      <v-col cols="12" sm="12" md="6" v-if="user.tipo == 'ADMIN' || (user.tipo == 'GERENTE' && user.franquia)">
        <v-autocomplete
          outlined
          dense
          v-model="empresaSelecionada"
          :items="empresas"
          item-text="nome"
          item-value="id"
          label="Selecione a empresa"
          @input="carregaVouchers(empresaSelecionada)"
        ></v-autocomplete>
      </v-col>
    </v-row>
    <v-row>
      <v-col ls="12" sm="12" md="12" lg="12">
        <v-data-table
          :search="tabela.busca"    
          :headers="tabela.cabecalho"
          :items="tabela.conteudo"
          class="elevation-1"
          style="border-radius: 10px;"
          :loading="tabela.carregamento"
          loading-text="Buscando itens..."
        >
          <template v-slot:[`item.status`]="{ item }">
            <v-chip :color="item.status == 'LIVRE' ? 'green' : 'red'" dark>{{ item.status }}</v-chip>
          </template>
          <template v-slot:top>
            <v-toolbar flat color="white" style="border-radius: 10px;">
              <v-toolbar-title class="textoUser">VOUCHERS</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="tabela.busca"
                append-icon="search"
                label="Pesquisa"
                single-line
                hide-details
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-btn text @click="dialogoVoucher = true" tile color="#2C2E83" :disabled="user.tipo == 'ADMIN' || (user.tipo == 'GERENTE' && user.franquia) ? empresaSelecionada == '' : false">
                <v-icon left dark>add_circle</v-icon>Adicionar voucher
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:[`item.kwh`]="{ item }">
            <td v-if="item.kwh">{{ item.kwh }}</td>
            <p v-else style="margin: 0px; color: #ccc">Não se aplica</p>
          </template>
          <template v-slot:[`item.tempo`]="{ item }">
            <td v-if="item.tempo">{{ item.tempo }}</td>
            <p v-else style="margin: 0px; color: #ccc">Não se aplica</p>
          </template>
          <template v-slot:[`item.valor`]="{ item }">
            <td>R$ {{ item.valor }}</td>
          </template>
          <template v-slot:[`item.created`]="{ item }">
            <td>{{ transformaData(item.created, 'DD/MM/YYYY') }} às {{ transformaData(item.created, 'HH:mm:ss') }}</td>
          </template>
          <template v-slot:[`item.dataHoraUso`]="{ item }">
            <td v-if="item.dataHoraUso">{{ transformaData(item.dataHoraUso.replace('.000Z', '-03:00'), 'DD/MM/YYYY') }} às {{ transformaData(item.dataHoraUso.replace('.000Z', '-03:00'), 'HH:mm:ss') }}</td>
          </template>
        </v-data-table>
      </v-col>

      <v-dialog v-model="dialogoVoucher" persistent max-width="400px">
        <v-card>
          <v-card-title>{{ formTitleProd }}</v-card-title>
          <v-card-text>
            <v-row dense>
              <v-col cols="12">
                <v-select
                  v-model="produtoSelecionado"
                  label="Produto"
                  outlined
                  dense
                  hide-details
                  color="#94AAB4"
                  clearable
                  :items="produtos"
                  item-text="descricao"
                  item-value="id"
                  :return-object="true"
                ></v-select>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="red" @click="dialogoVoucher = false">Cancelar</v-btn>
            <v-btn text color="primary" @click="salvarVoucher" :disabled="!produtoSelecionado">Salvar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <Snackbar ref=chamaSnackbar />
  </v-container>
</template>

<script>
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  import moment from 'moment'
  export default {
    components: {Snackbar},
    data: () => ({
      date: new Date().toISOString().substr(0, 10),
      mask:"##:##:##",
      menu: false,
      menu2: false,
      search:'',
      videoExibido: '',
      addUser: false,
      dialogoVoucher: false,
      tabela: {
        busca: '',
        cabecalho: [
          { text: 'Código', value: 'codigo' },
          { text: 'Valor ', value: 'valor' },
          { text: 'Tempo', value: 'tempo' },
          { text: 'kW/h', value: 'kwh' },
          { text: 'Status', value: 'status' },
          { text: 'Criado em', value: 'created' },
          { text: 'Usado em', value: 'dataHoraUso' },
        ],
        carregamento: false,
        conteudo: [],
      },
      empresaSelecionada: '',
      produtoSelecionado: null,
      empresas: [],
      perfis: [],
      editedIndex: -1,
      vouchers: [],
      produtos: [],
      events: [],
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitleProd () {
        return this.editedIndex === -1 ? 'Adicionar novo voucher' : 'Editar voucher'
      },  
    }),

    watch: {
      dialogoVoucher(val) {
        if (val == false) {
          setTimeout(() => {
            this.produtoSelecionado = null
          }, 300)
        }
      },
    },

    mounted () {
      if (this.user.tipo == 'ADMIN' || (this.user.tipo == 'GERENTE' && this.user.franquia)) {
        this.carregaEmpresas()
      } else {
        this.carregaVouchers(this.companyobj.id)
      }
    },

    methods: {
      async carregaEmpresas() {
        let filter

        if (this.user.tipo == 'GERENTE' && this.user.franquia) {
          filter = {
            where: {"franquia": this.user.franquia},
            order: "nome ASC",
            fields: {"nome": true, "id": true}
          }
        }
        else {
          filter = {
            order: "nome ASC",
            fields: {"nome": true, "id": true}
          }
        }

        await axios.get(baseApiUrl + 'Empresas?filter=' + JSON.stringify(filter) + '&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.empresas = response.data
          }
        })
      },

      async carregaVouchers(empresaId) {
        this.tabela.carregamento = true
        this.tabela.conteudo = []
        this.carregaProdutos(empresaId)

        await axios.get(baseApiUrl + 'Vouchers?filter={"where":{"empresaId":"' + empresaId + '"}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          this.tabela.conteudo = response.data
          this.tabela.carregamento = false
        })       
      },

      async carregaProdutos(empresaId) {
        await axios.get(baseApiUrl + 'Produtos?filter={"where":{"empresaId":"' + empresaId + '"}, "order": "descricao ASC"}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data) {
            this.produtos = response.data
          }
        })
      },

      editItem(item) {
        this.editedIndex = this.tabela.conteudo.indexOf(item)
        this.voucher = Object.assign({}, item)
        this.dialogoVoucher = true
      },

      async salvarVoucher() {
        let vm = this

        if (this.produtoSelecionado) {
          let dados = {
            "codigo": await this.retornaCodigo(),
            "valor": this.produtoSelecionado.preco,
            "status": "LIVRE",
            "empresaId": this.user.tipo == 'ADMIN' || (this.user.tipo == 'GERENTE' && this.user.franquia) ? this.empresaSelecionada : this.companyobj.id,
          }

          if (this.produtoSelecionado.tipoProduto == 'KW') {
            dados.kwh = this.produtoSelecionado.kwh
            dados.tipo = 'KW'
          }
          else {
            dados.tempo = this.produtoSelecionado.tempo
            dados.tipo = 'TEMPO'
          }

          await axios.post(baseApiUrl + 'Vouchers/replaceOrCreate?access_token=' + sessionStorage.getItem('accToken'), dados)
          .then(response => {
            if (response.data) {
              vm.$refs.chamaSnackbar.snack("green", "Voucher " + response.data.codigo + " criado!", "SUCESSO")
              this.dialogoVoucher = false
              this.carregaVouchers(this.user.tipo == 'ADMIN' || (this.user.tipo == 'GERENTE' && this.user.franquia) ? this.empresaSelecionada : this.companyobj.id)
            }
          })
          .catch(() => {
            vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao realizar operação, tente novamente", "DESCULPE")
          })
        } else {
          vm.$refs.chamaSnackbar.snack("orange", "Para continuar, escolha um produto", "ATENÇÃO")
        }
      },

      geradorDeCodigo() {
        const caracteres = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        let codigo = '';

        for (let i = 0; i < 6; i++) {
          const randomIndex = Math.floor(Math.random() * caracteres.length);
          codigo += caracteres[randomIndex];
        }

        return codigo;
      },

      async retornaCodigo() {
        let codigo = await this.geradorDeCodigo()
        let count = 0

        await axios.get(baseApiUrl + 'Vouchers/count?where={"codigo":"' + codigo + '"}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data && response.data.count == 0) {
            count = response.data.count
          }
        })

        if (count == 0) {
          return codigo
        } else {
          this.retornaCodigo()
        }
      },

      transformaData(data, formato) {
        return moment(data).format(formato);
      },
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px; width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
    font-size: 14px;
  }
</style>
